<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="片区名称" prop="title" class="sj">
					<Input v-model="formValidate.title" placeholder="请输入名称"></Input>
				</FormItem>
			
				<!-- <FormItem label="负责人" prop="empId" class="sj">
					<Select v-model="formValidate.empId" placeholder="请选择负责人">
						<Option  v-for="(item,i) in emps" :value="item.id" :key="item.id">{{item.name}}-{{item.phone}}</Option>
						
					</Select>
				</FormItem> -->
				<!-- <FormItem label="片区设备"  class="sj">
					<Select v-model="formValidate.macIds" multiple style="width:300px" max-tag-count='10' filterable='true'>
						<Option  v-for="(item,i) in macs" :value="item.id" :key="item.id">{{item.id}}-{{item.address}}</Option>
						
					</Select>
				</FormItem> -->
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				emps:[],
				macs:[],
				formValidate: {
					title: '',
					empId:'',
					macIds:[],
					districtId:''
				},
				ruleValidate: {
					title: [{
						required: true,
						message: '片区名称！！！',
						trigger: 'blur'
					}],
					// empId: [{
					// 	required: true,
					// 	message: '片区负责人！！！',
					// 	trigger: 'blur'
					// }],
					

				}

			}
		},
		created() {
			//this.queryEmp()
			if(this.$route.query.parentId!=undefined){
				let parentId=this.$route.query.parentId
				this.formValidate.districtId=parentId
			}
			
			//this.queryMac()
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						_this.formValidate.title=_this.formValidate.title.trim()
						
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/plat/oper/emp/district/add',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			queryEmp(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/page/pq',
				    data: {page:0,size:100},
					_this: _this,
					success: function(data) {
						_this.emps=data.empPage.content
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryMac() {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: {page:0,size:200},
					_this: _this,
					success: function(data) {
						_this.macs = data.macFaultDetailss.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		},
		
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/district/add.vue